import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';

const PopupTermCond = ({ execActionConfirm = null, popupLegalText = '' }) => {
    
    const handleConfirm = (event) => {
        execActionConfirm && execActionConfirm(event);
    }

    return (
        <div id="message-popup-terms" className="white-popup message-popup-simple">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <p className="text-center mb-4 red">
                                    <strong>Términos y legales</strong>
                                </p>
                                <div className="text-center mb-4">
                                    {popupLegalText!==''
                                        ?
                                        <p dangerouslySetInnerHTML={{__html: popupLegalText}}></p>
                                        :
                                        <Loading type=" size-xs" />
                                    }
                                </div>
                                <div className="text-center">
                                    <a href="#" onClick={(event) => handleConfirm(event)} className="btn">
                                        Aceptar
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

PopupTermCond.propTypes = {
    execActionConfirm: PropTypes.func, 
    popupLegalText: PropTypes.string
};
export default PopupTermCond;
